export default () => '<div class="content">Ecofoot surface is required for EcoFoot2 plus products.</div>';
